import { Card, Spinner } from '@leroy-merlin-br/backyard-react-ui'
import { useEffect, useState } from 'react'

import emitter from 'garden/src/js/utils/emitter'

import { getStockRequest } from 'reactShared/services/hybris/stock'

import ContentStockAssistedSale from 'reactSite/Product/components/StockAssistedSale/ContentStockAssistedSale.js'
import SapStockList from 'reactSite/Product/components/StockAssistedSale/SapStockList.js'

import { useProfile } from 'catalog/hooks/use-profile'

import * as S from './styled'

const StockInfo = ({ id, onClose }) => {
  const [apiData, setApiData] = useState(null)
  const { profile } = useProfile()

  useEffect(() => {
    if (!id || !profile.storeSlug) return

    const { request, cancelRequest } = getStockRequest({
      id,
      storeSlug: profile.storeSlug
    })

    const fetchStock = async () => {
      try {
        const { data } = await request()
        setApiData(data)
      } catch (error) {
        if (error.message) {
          emitter.emit('stickyFeedback:error', {
            title: 'Ops! Ocorreu o seguinte erro:',
            content: error
          })
          onClose()
        }
      }
    }

    fetchStock()

    return () => {
      cancelRequest()
    }
  }, [id, onClose, profile])

  return (
    <Card>
      {!apiData
        ? <S.SpinnerWrapper><Spinner color="green" size="zetta" /></S.SpinnerWrapper>
        : <S.Wrapper>
            <ContentStockAssistedSale
              store={apiData.stocks.store}
              warehouses={apiData.stocks.warehouses}
              unit={apiData.stocks.unit}
              hideStock={onClose}
            />

            <SapStockList
              stores={apiData.stocks.otherStores}
              unit={apiData.unit}
            />
        </S.Wrapper>
      }
    </Card>
  )
}
export default StockInfo
